module.exports = __webpack_public_path__ + "static/media/cloud-3-500.01f6880c.png";